<template>
  <section
    :id="sectionId"
    class="image-with-cards-and-text-module-component">
    <div class="inner-container">
      <div class="top-content">
        <div class="left-content">
          <BlurBG
            :id="blueBox"
            theme="dark"
            :blob-size="1.5">
            <template #default>
              <div
                class="blue-content"
                v-html="props.data.blue_card_content"></div>
            </template>
          </BlurBG>
        </div>
        <div class="right-content">
          <div class="image-container">
            <img
              :src="data.image.url"
              alt="Image" />
          </div>
          <div
            :id="grayBox"
            class="gray-content"
            v-html="data.gray_card_content"></div>
        </div>
      </div>

      <div
        class="bottom-content"
        v-html="data.bottom_text_content"></div>
      <!-- Insert your HTML code here -->
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ImageWithCardsAndTextComponent",
  "CLASSNAME": "image-with-cards-and-text-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import { ref, onMounted } from 'vue'
import BlurBG from '../utility/BlurBG.vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
const props = defineProps(['data'])
import useUtils from '@/composables/useUtils'

gsap.registerPlugin(ScrollTrigger)

const { genUUID } = useUtils()
const blueBox = ref(`blueBox-${genUUID()}`)
const grayBox = ref(`grayBox-${genUUID()}`)
const sectionId = ref(`sectionId-${genUUID()}`)

const animate = () => {
  let mm = gsap.matchMedia()
  mm.add('(min-width: 768px)', () => {
    gsap.fromTo(
      `#${blueBox.value}`,
      { y: 60 },
      {
        y: 0,
        scrollTrigger: {
          trigger: `#${blueBox.value}`,
          start: 'top-=50% center',
          end: 'bottom+=50% center',
          scrub: true,
        },
      }
    )

    gsap.fromTo(
      `#${grayBox.value}`,
      { y: -40 },
      {
        y: 0,
        scrollTrigger: {
          trigger: `#${grayBox.value}`,
          start: 'top-=50% center',
          end: 'bottom+=50% center',
          scrub: true,
        },
      }
    )
  })
}

onMounted(() => {
  animate()
})
</script>

<style lang="scss">
.image-with-cards-and-text-module-component {
  .inner-container {
    @apply px-md py-10 lg:px-[100px];

    .top-content {
      @apply flex flex-col gap-10 lg:flex-row lg:gap-0;

      .left-content {
        @apply lg:mt-12 lg:h-fit lg:w-1/2;

        .blue-content {
          @apply rounded-2xl p-7 lg:p-14;

          p {
            @apply body-md text-white lg:body-lg;

            &:last-child {
              @apply mb-0;
            }

            strong {
              @apply header-4 text-bicara-yellow;
            }
          }
        }
      }

      .right-content {
        @apply mb-7 flex flex-col gap-10 lg:mb-0 lg:w-1/2 lg:flex-1;

        .gray-content {
          @apply rounded-2xl bg-bicara-white p-7 lg:p-14;

          p {
            @apply body-md text-bicara-charcoal lg:body-lg;

            &:last-child {
              @apply mb-0;
            }
          }
        }

        .image-container {
          @apply relative flex items-center justify-center px-10;
        }
      }
    }

    .bottom-content {
      @apply p-7 text-center lg:mt-12;

      p {
        @apply body-sm text-bicara-charcoal lg:body-md;

        &:last-child {
          @apply mb-0;
        }
      }
    }
  }
}
</style>
